<header class="app-header navbar">

  <!-- Mobile: hamburger (visible < lg, hidden on desktop) -->
  <button *ngIf="showSidebarToggles" class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler aria-label="Toggle navigation">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  </button>

  <!-- Brand / Logo -->
  <a class="navbar-brand" href="#">
    <img class="brand-logo" src="assets/img/logo.png" alt="LC All In One" />
  </a>

  <!-- Desktop: sidebar collapse button (visible lg+, hidden mobile) -->
  <button *ngIf="showSidebarToggles" class="nav-sidebar-toggle d-none d-lg-flex" type="button" appSidebarToggler aria-label="Toggle sidebar">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  </button>

  <!-- App title (desktop only) -->
   <div *ngIf="!isProd" style="background-color: red; padding: 10px; color: white; font-weight: bold; border-radius: 10px; z-index: 100;">SAAT INI ANDA DALAM MODE STAGING!</div>
  <span *ngIf="isProd" class="navbar-app-title d-none d-lg-inline">LC All In One</span>

  <!-- Slot opsional di samping judul, dipakai layar kasir untuk pilihan periode -->
  <ng-content select="[headerSlot]"></ng-content>

  <!-- Right side -->
  <ul class="nav navbar-nav ml-auto d-flex align-items-center flex-row">

    <li class="nav-item dropdown" ngbDropdown placement="bottom-right">
      <a
        class="nav-link user-toggle"
        data-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        ngbDropdownToggle
        (click)="(false)"
      >
        <div class="user-avatar">{{ user?.name?.charAt(0)?.toUpperCase() }}</div>
        <span class="user-name d-none d-lg-inline">{{ user?.name }}</span>
        <svg class="chevron-icon d-none d-lg-block" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </a>

      <div class="dropdown-menu dropdown-menu-right user-dropdown" ngbDropdownMenu>
        <div class="dropdown-header">
          <div class="user-dropdown-avatar">{{ user?.name?.charAt(0)?.toUpperCase() }}</div>
          <div class="user-dropdown-info">
            <strong>{{ user?.name }}</strong>
            <small>{{ user?.username }}</small>
          </div>
        </div>
        <div class="dropdown-divider"></div>

        <!-- Theme Switcher -->
        <div class="theme-switcher-wrap">
          <span class="theme-switcher-label">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
            </svg>
            Tema
          </span>
          <div class="theme-options">
            <button
              type="button"
              class="theme-opt"
              [class.theme-opt--active]="themeService.mode === 'light'"
              (click)="setTheme('light')"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/>
                <line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/>
                <line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
              Light
            </button>
            <button
              type="button"
              class="theme-opt"
              [class.theme-opt--active]="themeService.mode === 'dark'"
              (click)="setTheme('dark')"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
              Dark
            </button>
            <button
              type="button"
              class="theme-opt"
              [class.theme-opt--active]="themeService.mode === 'system'"
              (click)="setTheme('system')"
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
              </svg>
              System
            </button>
          </div>
        </div>

        <div class="dropdown-divider"></div>
        <a class="dropdown-item logout-item" routerLink="/logout">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Logout
        </a>
      </div>
    </li>
  </ul>

</header>
